import { useInfiniteQuery } from '@tanstack/react-query';
import { auditApi } from '@/api/audit';
import { queryKeys } from '@/lib/queryKeys';

const PAGE = 50;

/** The audit trail, filtered by action family and outcome, newest first. */
export function useAuditEvents(family: string, result: string) {
  return useInfiniteQuery({
    queryKey: queryKeys.audit(family, result),
    initialPageParam: null as string | null,
    queryFn: ({ pageParam }) =>
      auditApi.list({ limit: PAGE, ...(family ? { action: family } : {}), ...(result ? { result } : {}), cursor: pageParam }),
    getNextPageParam: (last) => last.nextCursor,
  });
}

/** What the trail says about one thing, newest first: a server's journal (ADR-0058). */
export function useEntityAudit(entityType: string, entityId: string, enabled = true) {
  return useInfiniteQuery({
    queryKey: queryKeys.auditOf(entityType, entityId),
    initialPageParam: null as string | null,
    queryFn: ({ pageParam }) => auditApi.list({ limit: PAGE, entityType, entityId, cursor: pageParam }),
    getNextPageParam: (last) => last.nextCursor,
    enabled,
  });
}
